import { all, call, put, takeEvery } from 'redux-saga/effects'
import getBillingHistory, { getInvoice } from 'services/billingHistory'
import { store as reduxStore } from 'index'

import actions from './actions'

export function* GET_BILLING_HISTORY() {
  yield put({
    type: 'billingHistory/SET_STATE',
    payload: {
      isBillingHistoryLoading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const success = yield call(getBillingHistory, activeApp)

  if (success && success.data) {
    yield put({
      type: 'billingHistory/SET_STATE',
      payload: {
        invoices: success.data.invoices,
        paymentLink: success.data.paymentLink,
        isBillingHistoryLoading: false,
      },
    })
  } else {
    yield put({
      type: 'billingHistory/SET_STATE',
      payload: {
        invoices: [],
        paymentLink: '',
        isBillingHistoryLoading: false,
      },
    })
  }
}
export function* DOWNLOAD_INVOICE({ payload }) {
  const DownloadedData = yield call(getInvoice, payload.activeApp, payload.invoiceId)

  if (DownloadedData !== null) {
    yield put({
      type: 'billingHistory/SET_STATE',
      payload: { ...DownloadedData },
    })
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.GET_BILLING_HISTORY, GET_BILLING_HISTORY),
    takeEvery(actions.DOWNLOAD_INVOICE, DOWNLOAD_INVOICE),
  ])
}
